import { useCallback, useState } from "react";
import { Form, Spinner } from "react-bootstrap";
import { useDropzone } from "react-dropzone";

export const FileUploaderComp = ({
  bodyText,
  LabelText,
  labelClassName,
  onChange,
  errors,
  required,
  acceptImages = false,
}) => {
  const [loading, setLoading] = useState();
  const [fileError, setFileError] = useState("");

  const onDrop = useCallback((acceptedFiles, rejectedFiles) => {
    setFileError("");

    if (rejectedFiles.length > 0) {
      setFileError("Please select a valid image file (JPG, PNG, GIF, WebP)");
      return;
    }

    if (acceptedFiles.length > 0) {
      HandlePicture(acceptedFiles[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const dropzoneConfig = acceptImages
    ? {
        onDrop,
        accept: {
          "image/*": [".jpeg", ".jpg", ".png", ".gif", ".webp", ".svg"],
        },
        maxFiles: 1,
        maxSize: 5 * 1024 * 1024, // 5MB
      }
    : { onDrop };

  const { getRootProps, getInputProps, isDragActive } = useDropzone(
    dropzoneConfig
  );

  const HandlePicture = async (e) => {
    const fileUploaded = e;

    // If acceptImages is true, pass the file object to onChange
    // Otherwise, upload to Cloudinary and pass the URL
    if (acceptImages) {
      onChange(fileUploaded);
      return;
    }

    try {
      const formData = new FormData();

      formData.append("file", fileUploaded);
      formData.append("upload_preset", "svmprhvf");

      setLoading(true);
      await fetch("https://api.cloudinary.com/v1_1/afrilocales/upload", {
        method: "POST",
        body: formData,
      })
        .then((response) => {
          return response.text();
        })
        .then((data) => {
          setLoading(false);
          return onChange(JSON.parse(data).secure_url);
        });
    } catch (error) {
      console.error("Upload error:", error);
    }
    setLoading(false);
  };

  const Loader = () => {
    return (
      <Spinner size="sm" animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  };

  return (
    <div>
      <div>
        {LabelText && (
          <Form.Label className={labelClassName}>
            {LabelText}

            {required && <span className="text6">*</span>}
          </Form.Label>
        )}
      </div>
      <div {...getRootProps()}>
        <input {...getInputProps()} />
        {
          <div className="d-inline rounded border-2 pointer">
            {isDragActive && <div className="">{bodyText}</div>}
            <div className="d-flex justify-content-start align-items-center">
              {bodyText}
              {loading && <Loader />}
            </div>
          </div>
        }
      </div>
      {fileError && (
        <small className="text-danger mt-2 d-block">{fileError}</small>
      )}
      {errors?.map((error, i) => (
        <small className="text-danger mt-2" key={i}>
          {error}
        </small>
      ))}
    </div>
  );
};
